import { useMemo, useState, useEffect } from "react";
import moment from "moment-timezone";
import { DST_TZ, LST_TZ } from '../../../constants';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useTimeZone} from '../../../store/actions';
import { useStoreContext } from '../../../store/context';
import { TimeZones } from "../../../types";

export default function TimeZone() {
	const [state, dispatch] = useStoreContext();
  const setUserTimeZone = useTimeZone(dispatch);
  const [tz, setTz] = useState('UTC');
  const [currTimeZone, setCurrTimeZone]=useState('');
  const [tzOption, setTzOption] = useState('');
  const [dateState, setDateState] = useState(new Date());
  const [prevTime, setPrevTime]=useState<number>(0);
  const [timeZoneList, setTimeZoneList]=useState<TimeZones[]>();
  const [prevTimeZoneList, setPrevTimeZoneList] =useState<TimeZones[]>();
  useEffect(() => {
    setInterval(() => setDateState(new Date()), 1000);
  }, []);

  useEffect(()=>{
    if(state.userTimeZone){
      if(state.currentSliderDate!==prevTime){
        if(moment.tz(state.currentSliderDate, 'America/New_York').isDST()){
          setTimeZoneList(DST_TZ)
        }
        else{
          setTimeZoneList(LST_TZ)
        }
        setPrevTime(state.currentSliderDate)
      }
    }
  },[state.currentSliderDate, prevTime, setTimeZoneList, state.userTimeZone]);

  useMemo(() => {
    if((currTimeZone!==tz && tz)||(prevTimeZoneList!==timeZoneList)){
      setPrevTimeZoneList(timeZoneList)
      const filterTimeZone = timeZoneList?.find(timezone=> 
        timezone.offset ===  Number(moment(state.currentSliderDate).tz(tz).utcOffset()/60)
      );      
      if(filterTimeZone){
        setTzOption(filterTimeZone.code);
        setCurrTimeZone(tz);
        setUserTimeZone(filterTimeZone);
      }
    }
  }, [tz, currTimeZone, setTzOption, setCurrTimeZone, setUserTimeZone, timeZoneList,prevTimeZoneList, state.currentSliderDate]);

  const handleChange = (e:any) =>{
    setTzOption(e.target.value);
    const filterTimeZone = timeZoneList?.find(timezone=> e.target.value===timezone.code);
    if(filterTimeZone){
        setUserTimeZone(filterTimeZone);
        setTz(filterTimeZone.id[0]);
    }
  }

  return (
    <div style={{ display: 'inline' }}>
      <section
        aria-label="Current Date and Time"
        style={{ display: 'inline-block', paddingRight: '1rem', verticalAlign: 'middle', width: '115px' }}
      >
        <div style={{ display: 'block' }}>
          {dateState.toLocaleString('en-GB', {
            timeZone: state.userTimeZone.id[0],
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: true,
          })}
        </div>
        <div style={{ display: 'block' }}>
          {dateState.toLocaleDateString('en-GB', {
            timeZone: state.userTimeZone.id[0],
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          })}
        </div>
      </section>

      <label id='timeZones'>
        <span style={{ visibility: 'hidden', width: '0%', display: 'inline-flex' }}>Time Zone</span>
        <Select
          style={{
            width: '4.5rem', marginTop: '2%',
            height: '3rem',
            fontSize: '.9rem', color: 'black',
            backgroundColor: 'white'
          }}
          id="timeZones"
          onChange={handleChange}
          value={tzOption}
          label="timeZones"
          labelId="timeZones"
        >
          {timeZoneList?.map((timezone) => (
            <MenuItem value={timezone.code} key={timezone.code}>
              {timezone.offset > 0 ? (`${timezone.code} (+${timezone.offset})`) : (`${timezone.code} (${timezone.offset})`)}
            </MenuItem>
          ))}
        </Select>
      </label>
    </div>
  );
}
